import { Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo } from "react";
import isEmpty from "lodash/isEmpty";

import Config from "../../config";
import AddUserEmailPage from "../add-user-email-page";
import CompleteYourAd from "../../../pages/CompleteYourAd";

import "./style.css";
import PostServiceApi from "../../services/api/post-service";
import { getAuthUserProfile } from "../../features/application";
import PaymentSuccessBanner from "./templates/payment-success-banner";

const PaymentSuccessPage = ({ routeId }) => {
  const dispatch = useDispatch();
  const {
    authProfile,
    authAccount,
    initialized: appInitialized,
  } = useSelector((state) => state.application);

  const showUserEmailPage = useMemo(() => {
    if (!appInitialized) return true;
    const { email, emailVerified } = authAccount;
    return !(!isEmpty(email) && emailVerified);
  }, [appInitialized, authAccount]);

  useEffect(() => {
    if (isEmpty(authProfile)) {
      return;
    }
    if (
      !isEmpty(authProfile.bankTxRedirectStatus) &&
      authProfile.bankTxRedirectStatus !==
        Config.BANK_TRANSFER_STATUS.NOT_REQUIRED
    ) {
      PostServiceApi.postConfirmBankTransaction({
        postId: authProfile.id,
      }).then((response) => {
        if (!response.success) {
          // TODO: error handling
          return;
        }
        dispatch(getAuthUserProfile());
      });
    }
  }, [authProfile, dispatch]);

  return (
    <Grid container direction="column" className="payment-success-page">
      {showUserEmailPage ? (
        <AddUserEmailPage routeId={routeId} />
      ) : (
        <>
          <PaymentSuccessBanner />
          <CompleteYourAd />
        </>
      )}
    </Grid>
  );
};

export default PaymentSuccessPage;
